import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("CallBannerController connected")
    
    // Get event data from element
    const eventDataStr = this.element.dataset.eventData
    if (eventDataStr) {
      this.eventData = JSON.parse(eventDataStr)
    }
    
    // Start auto-dismiss timer (30 seconds)
    this.autoDismissTimer = setTimeout(() => {
      this.autoDismiss()
    }, 30000)
    
    // Add keyboard event listener for ESC key
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    // Clean up timer when element is removed
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
      this.autoDismissTimer = null
    }
    
    // Remove keyboard event listener
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    // Dismiss on ESC key
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.dismiss(event)
    }
  }

  navigate(event) {
    event.preventDefault()
    
    // Clear timer before navigating
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
      this.autoDismissTimer = null
    }
    
    const customerId = this.element.dataset.customerId
    
    if (customerId) {
      // Navigate to customer record
      window.location.href = `/contacts/${customerId}`
    } else {
      // If no customer ID, could open search or do nothing
      console.log("No customer ID available for navigation")
    }
  }

  dismiss(event) {
    if (event) {
      event.preventDefault()
    }
    
    // Clear timer on manual dismiss
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
      this.autoDismissTimer = null
    }
    
    // Add fade-out class
    this.element.classList.remove('call-banner-show')
    this.element.classList.add('call-banner-hide')
    
    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  autoDismiss() {
    console.log("Auto-dismissing banner after 30 seconds")
    
    // Same animation as manual dismiss
    this.element.classList.remove('call-banner-show')
    this.element.classList.add('call-banner-hide')
    
    // Remove from DOM after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}



